// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { DisplayEventProps } from '@Organisms/Timeline/DisplayEvent';
import React, { ReactElement } from 'react';

import './EventCard.scss';

interface EventCardProps extends DisplayEventProps {
    children?: ReactElement;
    className?: string;
}

export const EventCard = ({ currentEvent, children, className }: EventCardProps): ReactElement | null => {
    return currentEvent ? (
        <div className={classList('event-card', className)}>
            {children ? <div className="event-card__render">{children}</div> : null}
        </div>
    ) : null;
};
